module.exports = __webpack_public_path__ + "static/media/question.a46e8bc1.svg";